export default {
  ItemBatteryRangeIcon: () =>
    import(
      /* webpackChunkName: "ItemBatteryRangeIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemBatteryRangeIcon.vue'
    ),
  ItemChargerDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemChargerDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemChargerDescriptionIcon.vue'
    ),
  ItemPedalDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemPedalDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemPedalDescriptionIcon.vue'
    ),
  ItemLockDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemLockDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemLockDescriptionIcon.vue'
    ),
  ItemFrameDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemFrameDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemFrameDescriptionIcon.vue'
    ),
  ItemForkDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemForkDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemForkDescriptionIcon.vue'
    ),
  ItemHandlebarDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemHandlebarDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemHandlebarDescriptionIcon.vue'
    ),
  ItemSaddleDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemSaddleDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemSaddleDescriptionIcon.vue'
    ),
  ItemSeatpostDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemSeatpostDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemSeatpostDescriptionIcon.vue'
    ),
  ItemStemDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemStemDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemStemDescriptionIcon.vue'
    ),
  ItemSprocketDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemSprocketDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemSprocketDescriptionIcon.vue'
    ),
  ItemTransmissionOfDriveIcon: () =>
    import(
      /* webpackChunkName: "ItemTransmissionOfDriveIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemTransmissionOfDriveIcon.vue'
    ),
  ItemColorIcon: () =>
    import(
      /* webpackChunkName: "ItemColorIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemColorIcon.vue'
    ),
  ItemGripDescriptionIcon: () =>
    import(
      /* webpackChunkName: "ItemGripDescriptionIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemGripDescriptionIcon.vue'
    ),
  ItemLightsPoweredByIcon: () =>
    import(
      /* webpackChunkName: "ItemLightsPoweredByIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemLightsPoweredByIcon.vue'
    ),
  ItemWheelSizeInchIcon: () =>
    import(
      /* webpackChunkName: "ItemWheelSizeInchIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemWheelSizeInchIcon.vue'
    ),
  ItemCoasterBrakeIcon: () =>
    import(
      /* webpackChunkName: "ItemCoasterBrakeIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Item/ItemCoasterBrakeIcon.vue'
    ),
}
